import React, {} from 'react';

import BaseElement from '../base';

function BulletedList(props) {

  function renderList() {

    const { attributes, children } = props;

    const unorderedListContainerAttributes = {
      ...attributes,
      className: ''
    };

    const unorderedListAttributes = {
      className: 'unordered-list'
    };

    return <div {...unorderedListContainerAttributes}>
      <ul {...unorderedListAttributes}>{children}</ul>
    </div>;

  }

  function renderMain() {

    return <BaseElement {...props}>
      {renderList()}
    </BaseElement>;

  }

  return renderMain();

}

export default BulletedList;